module.exports = __webpack_public_path__ + "img/SES_225422550.96ef82cd.jpg";